import classNames from "classnames";
import { useState } from "react";
import { useI18n } from "../../../hooks/useTranslations";
import { MenuOptionValue } from "../../../types";
import HeaderMenuOption, { Option } from "../HeaderMenuOption";
import SearchBar from "../SearchBar";
import styles from "./FilterOptionList.module.css";
import { compareOptions, filterOptionsBySearch, getFilterOptionKey } from "./useDistinctValues";

interface FilterOptionListProps {
  options: Option[];
  formatter?: (value: MenuOptionValue) => string | undefined;
  onToggle: (option: Option) => void;
  searchable?: boolean;
}

// The checkbox list of distinct values, shared by every filter mode that lets the user pick
// exact values from what's on the server: Text/Boolean filters, and the "Equals"/"Exact date(s)"
// modes of Number/Date filters.
const FilterOptionList = ({ options, formatter, onToggle, searchable = true }: FilterOptionListProps) => {
  const i18n = useI18n();
  const [searchTerm, setSearchTerm] = useState("");

  const visibleOptions = filterOptionsBySearch(options, searchable ? searchTerm : "", formatter, i18n).sort((a, b) =>
    compareOptions(a, b, formatter, i18n),
  );

  return (
    <>
      {searchable && (
        <SearchBar
          className={styles.filterSearch}
          placeholder={i18n.t.common.search}
          value={searchTerm}
          onChange={setSearchTerm}
        />
      )}
      <div className={styles.options}>
        {visibleOptions.length > 0 ? (
          visibleOptions.map((option) => (
            <HeaderMenuOption
              key={getFilterOptionKey(option.value)}
              className={styles.optionEnabled}
              option={option}
              updateFilters={onToggle}
              formatter={formatter}
            />
          ))
        ) : (
          <div className={classNames(styles.option, styles.optionDisabled)}>{i18n.t.common.noItemsFound}</div>
        )}
      </div>
    </>
  );
};

export default FilterOptionList;
